import { forwardRef } from "react";

type SketchOverlayCanvasProps = {
  className?: string;
};

const SketchOverlayCanvas = forwardRef<HTMLCanvasElement, SketchOverlayCanvasProps>(
  function SketchOverlayCanvas(
    { className = "absolute inset-0 w-full h-full pointer-events-none z-10" },
    ref,
  ) {
    return <canvas ref={ref} className={className} />;
  },
);

export default SketchOverlayCanvas;
